export const DESKTOP_REDESIGN_RECOMMENDATIONS_EXPERIMENT = 'bx_desktop_bx1106_redesign_recs_mainpage';

export const EXPERIMENTS: string[] = [DESKTOP_REDESIGN_RECOMMENDATIONS_EXPERIMENT];
